import StrayCouponsTable from "./StrayCouponsTable";
export default StrayCouponsTable;
